import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { ChequeCultureLegacy } from "../../legacyforms/ChequeCultureLegacy";
import { ClapService } from "../../../service/ClapService";
import { LinkProviderService } from "../../../service/LinkProviderService";
import "../../../layout/styles/inline-cgos.css";
import './FormulaireAncv.scss';
import {Accordion, AccordionTab} from "primereact/accordion";


import { useDispatch, useSelector } from "react-redux";
import {
  setFiche,
  setIban,
  setMaxVal,
  setOptJustificatif,
  setPac,
} from "../../../store/actions/actionSociale";
import { ActionSocialeService } from "../../../service/ActionSocialeService";
import { AgentService } from "../../../service/AgentService";
import { ChequeCultureService } from "../../../service/ChequeCultureService";

export const AncvNoticeInformation = ({ mode, hiddenNoticeButton, onConfirm, displayErrors }) => {
  const errors = {
    dod: 1,
    statut: 2,
    qf: 2,
    iban: 3,
    pac: 4,
    exercice:5,
    droits:6,
    siDossierValide:7
  };

  const user = useSelector((state) => state.usager.user);
  const actionSociale = useSelector((state) => state.actionSociale);
  const [currentActionSociale, setCurrentActionSociale] = useState({});
  const [baremes, setBaremes] = useState([]);
  const [valParticipation, setValParticipation] = useState(0);
  const [valMaxParticipation, setValMaxParticipation] = useState(0);
  const [enfants, setEnfants] = useState([]);
  const [displayBasic, setDisplayBasic] = useState(false);
  const [isJustificatifRequis, setIsJustificatifRequis] = useState();
  const [ibanMembre, setIbanMembre] = useState(null);
  const [enfantsAgeIntervalle, setEnfantsAgeIntervalle] = useState({});
  const [displayError, setDisplayError] = useState([]);
  const [activeIndex, setActiveIndex] = useState([]);

  const [hiddenButton, hideButton] = useState(hiddenNoticeButton);
  const dispatch = useDispatch();
  const history = useHistory();

  const actionSocialeService = new ActionSocialeService();
  const clapService = new ClapService();
  const agentService = new AgentService();
  const chequeCultureService = new ChequeCultureService();

  const linkService = new LinkProviderService();

  const  textAdressezVous="Pour en savoir plus ou si vous pensez qu'il y a une erreur, adressez-vous à votre ";


  useEffect(() => {

        getIbanMembre();
        getIsJustificatifRequis();
        getCurrentActionSociale();
      setActiveIndex([0]);
  }, []);
  
  useEffect(() => {
    dispatch(setOptJustificatif(isJustificatifRequis));
  }, [isJustificatifRequis]);

  useEffect(() => {
     dispatch(setMaxVal(valParticipation));
  }, [valParticipation]);

  useEffect(() => {
    dispatch(setIban(ibanMembre));
  }, [ibanMembre]);

  useEffect(() => {
    dispatch(setPac(enfants));
  }, [enfants]);

  const getFiche =  (actionSocial) => {
      agentService.getFicheAgent(user.numCgos, actionSocial.exercice).then((fiche) => {
          getBaremes(actionSocial,fiche.data);
      });
   }

  const getBaremes = async (actionSocial,fiche) => {
          const bareme = {
            casCode: actionSocial.codeActionSociale,
            delegId: actionSocial.codeDelegation,
            exercie: actionSocial.exercice,
            siActif: 1,
          };

          try {
            const { data } = await clapService.getBaremes(bareme);
            setBaremes(data);
            let valMax = 0;
            let val = 0;
            data.forEach((el, i) => {
                        if (valMax !== 0) return;
                        if(fiche != null && fiche.quotientFamilial == null){
                                   setValMaxParticipation(data[data.length-1].plafond);
                                   setValParticipation(data[data.length-1].valeur);
                                  return;
                         }
                        if (i === data.length - 1) {
                          if (Number(fiche.quotientFamilial.replace(",", ".")) >= Number(el.borne)) {
                            valMax = data[i].plafond;
                            val = data[i].valeur;
                          }
                        } else if (Number(fiche.quotientFamilial.replace(",", ".")) < Number(data[i + 1].borne)) {
                          valMax = el.plafond;
                          val = el.valeur;
                        }
            });
            setValMaxParticipation(valMax);
            setValParticipation(val);
          } catch (error) {
            console.log(error);
          }
        };


  const getCurrentActionSociale = () => {
    Object.values(actionSociale.listActionsSociale).forEach((as) => {
      if (
        as.codeActionSociale === actionSociale.cas &&
        as.exercice === actionSociale.exercice
      ) {
        setCurrentActionSociale(as);
        getFiche(as)
        return;
      }
    });
  };




  const getIsJustificatifRequis = async () => {
    try {
      const { data } = await chequeCultureService.getJustificatifRequis();
      setIsJustificatifRequis(data);
    } catch (error) {
      console.log(error);
    }
  };

  //Récuperation de l'IBAN de l'agent
  const getIbanMembre = async () => {
    try {
      const { data } = await clapService.getIbanMembre(user.numCgos);
      setIbanMembre(data.numIBan);
      if(!actionSociale.fiche.siDodEncours){
       if(!data.numIBan && !displayError.includes(errors.iban)) setDisplayError(prevState => [...prevState, errors.iban]);
      }
    } catch (error) {
      setDisplayError(prevState => [...prevState, errors.iban])
    }
  };



  const nextStep = () => {
    actionSocialeService.persistState(actionSociale);
    onConfirm(false);
    hideButton(true);
  };

  const getDateFormat = (date) => {
    return new Date(date).toLocaleDateString("fr-FR", {});
  };

  return (
    <div className="grid">
      <ChequeCultureLegacy />
      <div className="col-12 mx-auto">
        <div className="no_shadow_no_border card " style={{ display: !displayBasic ? "block" : "none" }}>
          <Accordion activeIndex={[0,1,2,3,4,5,6]} multiple onTabChange={(e) => setActiveIndex(e.index)} >
            <AccordionTab headerClassName="cgos-h3" header=" Quel est le service rendu ?">
            <p className="cld-p">
              <span
                style={{
                  fontSize: "10.0pt",
                  fontFamily: "Tahoma, sans-serif",
                }}
              >
                Le Chèque-vacances est <b>un moyen de paiement</b> accepté en France, dans les DROM-COM et à destination de l’Union Européenne. Il est utilisable par toute la famille, toute l’année.
                Il est accepté par un grand nombre d’enseignes dans les domaines de l’hébergement (<b>hôtels, campings, clubs de vacances…</b>), des loisirs et de la culture (<b>parcs d’attraction, cinémas, musées…</b>), de la restauration, des séjours et transports (<b>agences de voyage en ligne ou locales, billet de train, billet d’avion…</b>) et dans les loisirs sportifs (<b>activités sportives, clubs, location de matériel…</b>).
                <br/><br/>
                <b>Durée de validité</b>: deux ans en plus de l’année d’émission.
                <br/>
                <b>En fin de validité</b>: il pourra être échangé contre des titres de même valeur.
                <br/><br/>
                Ils sont disponibles sous deux formats :
              </span>
            </p>

            <ul style={{marginTop: '20px'}}>
              <li style={{listStyle: 'none'}}>
                <a href="https://leguide.ancv.com/enseignes-cvco" target="_blank"> <img src="/assets/image/u413.png" title="Cheque-Vacances connect" alt="Cheque-Vacances connect"/></a>
                <p style={{marginTop: '10px'}}>
                  A utiliser avec votre smartphone,<br/>
                  Un compte à activer en ligne et un accès à votre solde en temps réel,<br/>
                  Dépense au centime près,<br/>
                  Auprès du réseau <a href="https://leguide.ancv.com/enseignes-cvco" target="_blank">Chèques-vacances Connect</a>,<br/>
                  Possibilité de changer librement de format à tout moment des 30 € depuis leguide.ancv.com pour passer au format papier,<br/>
                  Une application mobile de paiement sans contact pour régler sur place ou à distance et en ligne.
                </p>
              </li>
              <li style={{listStyle: 'none', marginTop: '30px'}}>
                <a href="https://leguide.ancv.com/page/le-cheque-vacances-le-format-papier-classique" target="_blank"> <img src="/assets/image/u412.png" title="Cheque-Vacances classic" alt="Cheque-Vacances classic"/></a>
                <p style={{marginTop: '10px'}}>
                  Coupures papiers de 10, 20 et 50 euros,<br/>
                  Règlement sur place ou par courrier,<br/>
                  Auprès du réseau <a href="https://leguide.ancv.com/page/le-cheque-vacances-le-format-papier-classique" target="_blank">Chèques-vacances Classic</a>,<br/>
                  Possibilité de changer librement de format à tout moment, dès 30 €, depuis leguide.ancv.com pour passer au format digital.
                </p>
              </li>
            </ul>

            <br/>
            <div class="astuce-box-warning">
              <strong>Astuce choix du format</strong><br/>
              Avant de choisir, pour plus de sérénité, 
              <a href="https://leguide.ancv.com/ptl/thematique/list" target="_blank" style={{color: '#000'}}><u>consultez le guide ANCV</u> </a>
              pour vérifier si l'enseigne où vous souhaitez utiliser les chèques-vacances accepte tous les formats.
            </div>
            </AccordionTab>
            <AccordionTab headerClassName="cgos-h3" header="Suis-je concerné ?">
              <p className="cld-p">
                <span
                  style={{
                    fontSize: "10.0pt",
                    fontFamily: "Tahoma, sans-serif",
                  }}
                >
                <p>
                Oui si vous êtes un <b>agent en activité</b> ou <b>un retraité</b> (bénéficiant d’une retraite CNRAL liquidée dans un établissement adhérant au C.G.O.S). </p>
                </span>
              </p>
            </AccordionTab>
            <AccordionTab headerClassName="cgos-h3" header="Quand et à quelles conditions puis-je faire une demande ?" disabled={false}>
              <p className="cld-p">
                <span
                  style={{
                    fontSize: "10.0pt",
                    fontFamily: "Tahoma, sans-serif",
                  }}
                >
                  <p>Les demandes de chèques-vacances sont validées <b>dans la limite du budget disponible.</b></p>
                  <p>Vous devez avoir déjà envoyé votre dossier C.G.O.S,</p>
                  <p>La demande est étudiée <b>après l'ouverture de vos droits.</b></p>
                  <p><b>Il existe un délai d’attente entre deux prestations Chèques-vacances</b>. Ce délai dépend de la région C.G.O.S à laquelle votre établissement est rattaché. Pour en savoir plus, consultez <a href="https://www.cgos.info" target="_blank">notre site web</a>.</p>
                  <p>Vous pouvez choisir entre <b>une prestation avec épargne préalable</b> ou <b>avec un achat unique.</b></p>
                  <p>Une fois le contrat signé, la durée et le montant mensuel de votre épargne ne seront plus modifiables.</p>
                </span>
              </p>
            </AccordionTab>
            <AccordionTab headerClassName="cgos-h3" header="Que se passe t-il en cas de prélèvement non respecté ou d'arrêt de l'épargne ?" disabled={false}>
              <p className="cld-p">
              <span
                style={{
                  fontSize: "10.0pt",
                  fontFamily: "Tahoma, sans-serif",
                }}
              >
                 <p><b>Si vous demandez la rupture du contrat avant son terme</b>, vos versements vous seront <b>remboursés sans la participation du C.G.O.S</b>. Si cette demande de rupture fait suite à un événement familial particulier (décès, divorce, etc.), une Commission étudiera votre dossier.</p>
                 
                <p>
                  <b>Impayés et remboursement :</b>
                </p>

                <p style={{ marginLeft: "20px" }}>
                    <b>Achat unique :</b> En cas d’impayé, le contrat sera automatiquement annulé.
                </p>

                <p style={{ marginLeft: "20px" }}>
                    <b>Épargne :</b> En cas d’impayé sur la première mensualité, le montant de cette
                    mensualité sera reporté sur l’échéance suivante. En cas d’impayé sur
                    deux mensualités consécutives, le contrat sera automatiquement annulé
                    et vos versements seront automatiquement remboursés sans la
                    participation du C.G.O.S.
                </p>
              </span>

              </p>
            </AccordionTab>
            <AccordionTab headerClassName="cgos-h3" header="Comment est calculée la prestation ?" disabled={false}>
              <p className="cld-p">
                <span
                  style={{
                    fontSize: "10.0pt",
                    fontFamily: "Tahoma, sans-serif",
                  }}
                >
                  <p>Le montant de la prestation dépend de la somme épargnée ou versée et de votre quotient familial C.G.O.S.</p>
                </span>
              </p>

              {!((displayError.includes(errors.exercice) || displayError.includes(errors.droits) || displayError.includes(errors.dod) || displayError.includes(errors.siDossierValide)) ) && (
                  <table className="cld-table-2">
                <thead>
                  <tr>
                    <th style={{backgroundColor: '#dddcdd', color: '#000'}}>Mon quotient familial</th>
                    <th style={{backgroundColor: '#dddcdd', color: '#000'}}>Participation<br/> C.G.O.S</th>
                    <th style={{backgroundColor: '#dddcdd', color: '#000'}}>Participation C.G.O.S maximale</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {actionSociale.fiche.quotientFamilial == null? "non connu" : actionSociale.fiche.quotientFamilial.toString().replace('.', ',')}
                    </td>
                    <td>
                      {baremes.length > 0 && actionSociale.fiche.quotientFamilial == null ? baremes[baremes.length-1].valeur : valParticipation} %
                    </td>
                    <td>
                      {baremes.length > 0 && actionSociale.fiche.quotientFamilial == null ? baremes[baremes.length-1].plafond : valMaxParticipation} €
                    </td>
                  </tr>
                </tbody>
              </table>
              )}
              <p className="cld-p">
                <span
                  style={{
                    fontSize: "10.0pt",
                    fontFamily: "Tahoma, sans-serif",
                  }}
                >
                  Le tableau de référence :
                </span>
              </p>
              <table className="cld-table">
                <thead>
                  <tr>
                    <th style={{backgroundColor: '#eaf8fb', color: '#000'}}>Tranches de quotient familial de référence</th>
                    <th style={{backgroundColor: '#eaf8fb', color: '#000'}}>Participation<br/> C.G.O.S</th>
                    <th style={{backgroundColor: '#eaf8fb', color: '#000'}}>Participation C.G.O.S maximale</th>
                  </tr>
                </thead>
                <tbody>
                  {baremes.map((el, i) => {
                    let borne = "";
                    if (i >= 0 && i < baremes.length - 1) {
                      const borneToNumber = Number(baremes[i + 1].borne).toFixed(0);
                      borne = `de ${el.borne} à ${borneToNumber}`;
                    } else {
                      borne = `supérieur à ${Number(el.borne).toFixed(
                        0
                      )} ou non connu`;
                    }
                    return (
                      <tr key={i}>
                        <td>{borne}</td>
                        <td>{el.valeur} %</td>
                        <td>{el.plafond} €</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </AccordionTab>

            {isJustificatifRequis && (
            <AccordionTab headerClassName="cgos-h3" header="Quel(s) document(s) dois-je préparer ?" disabled={false}>
                <div class="card-justificatif" style={{backgroundColor: '#fff2d6', borderLeft: '5px solid #b38600'}}>
                  <div class="card-justificatif-body">
                    <div class="card-justificatif-img" style={{width: "13%", marginRight: "1%"}}>
                      <img src="/assets/image/DOC-gris.png" title="Bulletin de paie ou attestation de travail" alt="Icon Bulletin de paie ou attestation de travail"/>
                    </div>
                    <div class="card-justificatif-txt-container" style={{width: "85%", color: 'black'}}>
                      <div class="card-justificatif-titre pt-2">
                        <span
                          style={{
                            fontSize: "9.0pt",
                            fontFamily: "Tahoma, sans-serif",
                          }}
                        >
                          Justificatif de présence en établissement
                        </span>
                      </div>
                      <div className="card-justificatif-description">
                        <ul
                          style={{
                            listStyleType: "disc",
                            listStylePosition: "inside",
                            padding: 0,
                            margin: 0,
                            fontSize: "9.0pt",
                            fontFamily: "Tahoma, sans-serif",
                          }}
                        >
                          <li style={{ marginBottom: "4px" }}>
                            Bulletin de paie ou attestation de travail de moins d’un mois.
                          </li>
                          <li>
                            Décision administrative de congés parental à 100%.
                          </li>
                        </ul>
                      </div>

                    </div>
                  </div>
                </div>

              <div className="tutorial">
                <img className="tutorial-image" src="/assets/icon_youtube.png" title="Icone youtube" alt="icon youtube"/>{" "}
                <a
                  target="_blank"
                  href="https://www.youtube.com/watch?v=rQzzWn7Yz-o"
                >
                  <span
                    style={{
                      fontSize: "10.0pt",
                      fontFamily: "Tahoma, sans-serif",
                      color:"black",
                      textDecoration: "underline"
                    }}
                  >
                    # TutorielCGOS - Comment scanner un document
                  </span>
                </a>
              </div>
            </AccordionTab>)}



            <AccordionTab headerClassName="cgos-h3" header="Les grandes étapes de la demande" disabled={false}>
              <p className="cld-c">
                <ol>
                  <span
                    style={{
                      fontSize: "10.0pt",
                      fontFamily: "Tahoma, sans-serif",
                    }}
                  >
                    <li style={{marginBottom: '1%'}}>
                      Je choisis le <b>format CLASSIC ou CONNECT,</b>
                    </li>
                    <li style={{marginBottom: '1%'}}>
                      Je choisis un <b>paiement en une ou plusieurs fois,</b>
                    </li>
                    <li style={{marginBottom: '1%'}}>
                    <b>J'indique mes préférences</b> pour le montant, la durée et la date de démarrage du contrat,
                    </li>
                    <li style={{marginBottom: '1%'}}>
                      Si la <b>date de livraison </b> des chèques-vacance ne me convient pas <b>je modifie mes préférences,</b>
                    </li>
                    <li style={{marginBottom: '1%'}}>
                      Je signe le contrat et le mandat de prélèvement,
                    </li>
                    <li style={{marginBottom: '1%'}}>
                    Dès que le C.G.O.S a validé ma demande, le contrat démarre avec le 1er (ou le seul) prélèvement,
                    </li>
                    <li style={{marginBottom: '1%'}}>
                    Après le dernier prélèvement, je reçois mes chèques-vacances.
                    </li>
                  </span>
                </ol>
              </p>

            </AccordionTab>
          </Accordion>
          
          <div class="astuce-box-success mt-3">
            <strong>INFO</strong> : Demander cette prestation prend <strong>moins de 10 minutes</strong>
          </div>
          {!hiddenButton && (
            <div>
              <br></br>
              <div className="next-button-wrapper">
                 { displayErrors.length > 0
                                 ? <button type="button" className="btn_submit_modal" disabled style={{ pointerEvents: "none" }}> DEMANDER CETTE PRESTATION </button>
                                 : <button type="button" className="btn_submit_modal" style={{borderColor: "#999898"}} onClick={nextStep}> DEMANDER CETTE PRESTATION </button>}
              </div>
              <br></br>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
